import React from 'react';
import { HourglassSpinner } from '@cognixis-technology/common-react-components';

interface HourglassSpinnerWrapperProps {
  fullPage?: boolean;
  title?: string;
  subtitle?: string;
  primaryColor?: string;
  accentColor?: string;
}

/**
 * Wrapper for HourglassSpinner from @cognixis-technology/common-react-components
 * Provides a consistent interface for the loading spinner component
 * Memoized to prevent unnecessary re-renders when props haven't changed
 */
const HourglassSpinnerWrapperComponent: React.FC<HourglassSpinnerWrapperProps> = ({
  fullPage = true,
  title = 'Loading...',
  subtitle = 'Please wait',
  primaryColor,
  accentColor,
}) => {
  return (
    <HourglassSpinner
      fullPage={fullPage}
      title={title}
      subtitle={subtitle}
      primaryColor={primaryColor}
      accentColor={accentColor}
    />
  );
};

// Memoize the component to prevent re-renders when props haven't changed
export const HourglassSpinnerWrapper = React.memo(HourglassSpinnerWrapperComponent);

